import {
  distanceFromBottom,
  distanceFromLeft,
  distanceFromRight,
  distanceFromTop
} from "../distanceFromEdge";

export const tooltipFitsTop = ({ spacer, tooltipElem, triggerElem }) => {
  const tooltipHeight = tooltipElem.offsetHeight;
  const tooltipWidth = tooltipElem.offsetWidth;
  const triggerWidth = triggerElem.offsetWidth;

  const horizontalMargin = (tooltipWidth - triggerWidth) / 2;
  const fitsLeft = horizontalMargin < distanceFromLeft(triggerElem);
  const fitsRight = horizontalMargin < distanceFromRight(triggerElem);
  const fitsTop = spacer + tooltipHeight < distanceFromTop(triggerElem);

  return fitsLeft && fitsRight && fitsTop;
};

export const tooltipFitsBottom = ({ spacer, tooltipElem, triggerElem }) => {
  const tooltipHeight = tooltipElem.offsetHeight;
  const tooltipWidth = tooltipElem.offsetWidth;
  const triggerWidth = triggerElem.offsetWidth;

  const horizontalMargin = (tooltipWidth - triggerWidth) / 2;
  const fitsRight = horizontalMargin < distanceFromRight(triggerElem);
  const fitsLeft = horizontalMargin < distanceFromLeft(triggerElem);
  const fitsBottom = spacer + tooltipHeight < distanceFromBottom(triggerElem);

  return fitsBottom && fitsLeft && fitsRight;
};

export const tooltipFitsLeft = ({ spacer, tooltipElem, triggerElem }) => {
  const tooltipHeight = tooltipElem.offsetHeight;
  const tooltipWidth = tooltipElem.offsetWidth;
  const triggerHeight = triggerElem.offsetHeight;

  const verticalMargin = (tooltipHeight - triggerHeight) / 2;
  const fitsBottom = verticalMargin < distanceFromBottom(triggerElem);
  const fitsTop = verticalMargin < distanceFromTop(triggerElem);
  const fitsLeft = spacer + tooltipWidth < distanceFromLeft(triggerElem);

  return fitsBottom && fitsLeft && fitsTop;
};

export const tooltipFitsRight = ({ spacer, tooltipElem, triggerElem }) => {
  const tooltipHeight = tooltipElem.offsetHeight;
  const tooltipWidth = tooltipElem.offsetWidth;
  const triggerHeight = triggerElem.offsetHeight;

  const verticalMargin = (tooltipHeight - triggerHeight) / 2;
  const fitsBottom = verticalMargin < distanceFromBottom(triggerElem);
  const fitsRight = spacer + tooltipWidth < distanceFromRight(triggerElem);
  const fitsTop = verticalMargin < distanceFromTop(triggerElem);

  return fitsBottom && fitsRight && fitsTop;
};
